import React, { useState } from 'react';

function RiskFlagsPanel({ flags = [], narrative = '', onNarrativeClean = null }) {
  const [appliedFlags, setAppliedFlags] = useState(new Set());
  const [cleaningAll, setCleaningAll] = useState(false);

  const canClean = !!onNarrativeClean && !!narrative;

  function applySuggestion(flag, index) {
    if (!canClean || !flag.text || !flag.suggestion) return;
    const cleaned = narrative.replace(flag.text, flag.suggestion);
    onNarrativeClean(cleaned);
    setAppliedFlags(prev => new Set([...prev, index]));
  }

  function cleanAll() {
    if (!canClean) return;
    setCleaningAll(true);
    let cleaned = narrative;
    const newApplied = new Set();
    flags.forEach((flag, idx) => {
      if (flag.text && flag.suggestion && cleaned.includes(flag.text)) {
        cleaned = cleaned.replace(flag.text, flag.suggestion);
        newApplied.add(idx);
      }
    });
    onNarrativeClean(cleaned);
    setAppliedFlags(newApplied);
    setCleaningAll(false);
  }

  const unappliedCount = flags.filter((f, i) => f.suggestion && !appliedFlags.has(i)).length;

  return (
    <div className="ff-card ff-risk-panel" data-testid="risk-flags-panel">
      <div className="ff-flex-row--spread">
        <h3>Language Flags</h3>
        {canClean && unappliedCount > 0 && (
          <button
            className="ff-btn-primary ff-btn-xs"
            onClick={cleanAll}
            disabled={cleaningAll}
            data-testid="clean-all-speculation-btn"
          >
            Clean All ({unappliedCount})
          </button>
        )}
      </div>
      
      {flags.length === 0 ? (
        <p className="ff-no-flags">No obvious speculative language detected yet.</p>
      ) : (
        <div className="ff-flags-list">
          {flags.map((flag, index) => (
            <div key={index} className={`ff-flag-item${appliedFlags.has(index) ? ' ff-applied' : ''}`} data-testid={`risk-flag-${index}`}>
              <div className="ff-flag-label">{flag.label}</div>
              <div className="ff-flag-text">"{flag.text}"</div>
              {flag.suggestion && (
                <div className="ff-flag-suggestion">
                  <strong>Suggested fix:</strong> {flag.suggestion}
                </div>
              )}
              {canClean && flag.suggestion && !appliedFlags.has(index) && (
                <button
                  onClick={() => applySuggestion(flag, index)}
                  data-testid={`apply-fix-${index}`}
                  className="ff-action-btn ff-action-btn--success"
                >
                  Apply Fix
                </button>
              )}
              {appliedFlags.has(index) && (
                <span className="ff-applied-label">Applied</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default RiskFlagsPanel;
